//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RankingList from "~/components/ranking/RankingList.vue";

export default {
	name: "organisations-slug",
	components: {
		RankingList,
	},
	props: {
		slug: {
			type: String,
			required: true,
		},
		organisation: {
			type: Object,
			required: true,
		},
		ranking: {
			type: Object,
			required: true,
		},
	},
	methods: {
		getTitle(parliamentarian) {
			return `${parliamentarian.firstName} ${parliamentarian.lastName}`;
		},
		getTags(parliamentarian) {
			return [
				parliamentarian.canton,
				this.$store.getters.getPartyAbbreviation(parliamentarian.party),
			]; //, this.$store.getters.getFactionName(parliamentarian.faction)]
		},
		descString(parliamentarian) {
			return this.$store.getters[
				"rankings/getRankingDescParliamentarian"
			](parliamentarian, this.organisation, this.$i18n.locale);
		},
		getImgUrl(e) {
			return e.image
				? `https://www.parlament.ch/sitecollectionimages/profil/portrait-260/${e.image}.jpg`
				: `https://picsum.photos/250`;
		},
		getTo(parliamentarian) {
			return this.localePath({
				name: "organisations-slug-parliamentarian",
				params: {
					slug: this.slug,
					parliamentarian: parliamentarian.id,
				},
			});
		},
	},
	computed: {
		rankingList() {
			return this.$store.state.orderByDesc.ranking
				? this.ranking.ranking.parliamentarians
				: [...this.ranking.ranking.parliamentarians].reverse();
		},
	},
	nuxtI18n: {
		paths: {
			en: "/organisations/:slug",
			de: "/organisationen/:slug",
			fr: "/organisations/:slug",
			it: "/organizzazioni/:slug",
		},
	},
	mounted() {
		if (Object.keys(this.$route.query).length !== 0) {
			if (`party` in this.$route.query) {
				const partyId = parseInt(this.$route.query.party);
				if (
					this.$store.state.parties.find(
						(party) => party.id === partyId
					)
				) {
					this.$store.commit("filters/RESET", "ranking");
					this.$store.commit("filters/TOGGLE_FILTER", {
						view: "ranking",
						type: "party",
						element: parseInt(partyId),
					});
				} else {
					console.log(`party ID doesn't exist.`);
				}
			} else if (`faction` in this.$route.query) {
				const factionId = parseInt(this.$route.query.faction);
				if (
					this.$store.state.factions.find(
						(faction) => faction.id === factionId
					)
				) {
					this.$store.commit("filters/RESET", "ranking");
					this.$store.commit("filters/TOGGLE_FILTER", {
						view: "ranking",
						type: "faction",
						element: parseInt(factionId),
					});
				} else {
					console.log(`faction ID doesn't exist.`);
				}
			} else {
				console.log(`query parameters not supported.`);
			}
		}
	},
	head() {
		return {
			title: `${this.organisation.name} – VoteLog`,
		};
	},
};
